import React, {useState} from 'react';
import {extrasCard} from '../../content/food';

const Extras = ({onglet}) => {

    const [extras] = useState(extrasCard);


    return (
        <div className={onglet === 2 ? "visible" : "hidden"}>
            <section className='mx-auto'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-5 md:mx-20 xl:mx-48'>
                    {extras?.map(extra =>
                            <div key={extra.id} className='p-2 '>
                                <div className='grid grid-cols-3 shadow-lg bg-white rounded-lg h-32 xl:h-44'>
                                    <div className='col-span-1'>
                                        <img
                                            alt={extra.name}
                                            className='rounded-lg rounded-r-none object-center w-52 h-32 xl:h-44 object-cover'
                                            src={extra.picture}
                                        />
                                    </div>

                                    <div
                                        className='col-span-2 grid  p-3 shadow-lg shadow-none  bg-white bg-transparent rounded-lg rounded-l-none -mt-2 '>
                                        <h2 className=' tracking-tight text-base font-semibold uppercase text-secondary my-0.5'>
                                            {extra.name}
                                        </h2>
                                        <p className='text-gray-700 text-xs leading-snug'>
                                            {extra.description}
                                        </p>
                                        <div className=''>
                  <span className='mt-1 text-sm font-semibold text-gray-800 block '>
                      {extra.price}€
                  </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                    )}

                </div>
            </section>
        </div>
    );
};

export default Extras;